import { render, staticRenderFns } from "./SimulatorToolbarEditDetailsModal.vue?vue&type=template&id=2d89d408&scoped=true&"
import script from "./SimulatorToolbarEditDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SimulatorToolbarEditDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorToolbarEditDetailsModal.vue?vue&type=style&index=0&id=2d89d408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d89d408",
  null
  
)

export default component.exports